/**
 * The reducer registry enables Redux reducers to be added to the store’s reducer
 * after the store has been created. This allows Redux modules to be loaded
 * on-demand, without requiring all Redux modules to be bundled in the main
 * chunk for the store to correctly initialize. aka lazy loading Redux.
 */
export const ReducerRegistry = {
  // Callback to execute everytime a new reducer is added
  emitChange: null,
  // List of registered reducers
  reducers: {},
  // Register a new reducer
  register(name, reducer) {
    this.reducers = {
      ...this.reducers,
      [name]: reducer,
    };

    if (this.emitChange) {
      this.emitChange(this.reducers);
    }
  },
  // Define a callback to execute everytime a reducer is added
  setChangeListener(listener) {
    this.emitChange = listener;
  },
};
